
















import Vue from 'vue'
export default Vue.extend({
    props: {
        organizationName: {
            type: String,
            default: "Your Organization's Name"
        }
    }
})
